import { DOCUMENT } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'kp-payments-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
  readonly #document = inject(DOCUMENT);
  ngOnInit(): void {
    const loader = this.#document.getElementById('appLoader');
    if (loader) {
      loader.parentElement?.removeChild(loader);
    }
  }
}
